import React from 'react';

// Monochrome, stroke-only ball icon matching Feather's own icon shape
// (24x24 viewBox, currentColor stroke, no fill) - used next to FeatherIcon
// in places like the hero fact-chip strip (TournamentHero.js) where the
// colored BallIcon.js (used in TournamentGroupTable.js's own grid cell)
// would clash with the chip's single-color badge look.
const BallIconMono = ({ size = 24, className = '', ...otherProps }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`feather feather-ball ${className}`}
            {...otherProps}
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2c4 3.33 4 6.67 0 10s-4 6.67 0 10" />
        </svg>
    );
};

export default BallIconMono;
